import type { ButtonContentProps } from '@pearlconvert/ui/components/button/button.types'

import React from 'react'

const ButtonContent = (props: ButtonContentProps) => {
  const { children, ariaHidden = 'false' } = props

  if (!children) {
    return null
  }

  return (
    <span className="button__text" aria-hidden={ariaHidden}>
      {children}
    </span>
  )
}

export default ButtonContent
